import { forwardRef } from 'react';
import QRCode from 'qrcode';

const QrCodeGenerator = forwardRef(({ url = '' }, forwardedRef) => {
  const hanldeRenderQrCode = (ref) => {
    try {
      forwardedRef.current = ref;
      QRCode.toCanvas(ref, url, { width: 240, margin: 0 }, (error) => {
        if (error) {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return <canvas ref={hanldeRenderQrCode} />;
});

export default QrCodeGenerator;
